module.exports = __webpack_public_path__ + "media/images/gift-2-c2a90489e955f740554ae617052426aa.svg";